import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { useDarkMode } from '../utils/DarkModeProvider';
import stylesTableDarkMode from '../styles/TableDarkMode'
import stylesTableLightMode from '../styles/TableLightMode'
import InstanciasTabla from './InstanciasTabla';

export default function InstanciaCategoria({ elem }) {

    const { darkMode } = useDarkMode();

    return (
        Object.keys(elem).map((key, index) => {
            const hijo = elem[key]
            return (
                hijo && hijo.tipo === "item" ?
                    <InstanciasTabla key={index} elem={hijo} />
                    :
                    hijo && hijo.tipo === "categoria" &&
                    <InstanciaCategoria key={index} elem={hijo.hijos} />

            )
        })
    )
}